import {Component, Input, OnInit} from '@angular/core';
import {CityDTO} from '../../../shared/dto/city.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import swal from "sweetalert2";
import {InventoryModel} from '../../../shared/dto/inventory.model';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ApprovalPending} from '../../../shared/dto/approval-pending';
import {ApprovalService} from '../../../service/approval.service';

@Component({
  selector: 'app-add-new',
  templateUrl: './add-new.component.html',
  styleUrls: ['./add-new.component.scss']
})
export class AddNewComponent implements OnInit {
  @Input() invRecord: InventoryModel[];
  public invPopup: FormGroup;
  submitted: boolean = false;
  invModel: InventoryModel = new InventoryModel();

  constructor(private tokenStorageService: TokenStorageService,
              private applicantRequestService: ApplicantRequestService,
              public activeModal: NgbActiveModal,
              private approvalService: ApprovalService) { }

  ngOnInit() {
    this.invPopup = new FormGroup({
      from: new FormControl(null,[Validators.required]),
      to: new FormControl(null,[Validators.required]),
    });
  }

  get form() {
    return this.invPopup.controls;
  }


  onSubmit(){
    this.submitted = true;

    if (this.invPopup.invalid) {
      return;
    }

      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
          if(result.value) {
            this.invModel.from = this.invPopup.value.from;
            this.invModel.to = this.invPopup.value.to;
            this.invModel.user =  this.tokenStorageService.getUserObjectToken().username;
            //
            // this.applicantRequestService.saveInventory(this.invModel).subscribe(
            //   (success: string) => {
            //     console.log("Success " + success);
            //     this.approvalService.close();
            //     swal.fire("Success", "Details submitted successfully", "success");
            //
            //   },
            //   (error) => {
            //     this.approvalService.close();
            //     console.log("Error " + error);
            //     swal.fire("Error", "Details Not Submitted!", "error");
            //     // window.location.reload();
            //   },
            //   () => {
            //     // window.location.reload();
            //     //this.activeModal.close("Saved");
            //   }
            // );

            this.applicantRequestService.saveInventory(this.invModel).subscribe(
              value => {
                    this.approvalService.close();
                    swal.fire("Success", "Details submitted successfully", "success");

              },(error)=>{
                    this.approvalService.close();
                    swal.fire("Error", "Details Not Submitted!", "error");;

              },()=>{
                    window.location.reload();
              });

          }
        }, reason => {
        }
      );

  }

}
